import { Card, CardContent, Icon, IconButton, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

type Iprops = {
  title: string;
  count: number;
  link: string;
};
function DashboardItem({ title, count, link }: Iprops) {
  return (
    <Link
      to={link}
      style={{
        textDecoration: 'none',
      }}
    >
      <Card>
        <CardContent>
          <Typography textAlign={'center'} variant='h3'>
            {count}
          </Typography>
          <Typography textAlign='center' variant='body1'>
            {title}
          </Typography>
        </CardContent>
      </Card>
    </Link>
  );
}

export default DashboardItem;
